module.exports = __webpack_public_path__ + "./images/9428c7d3898bc1c06fd4674928c15e66.webp";